export enum ProductType {
  CONCRETE = "CONCRETE",
  MORTAR = "MORTAR",
  BINDER = "BINDER",
  SMALL_AGGREGATE = "SMALL_AGGREGATE",
  COARSE_AGGREGATE = "COARSE_AGGREGATE"
}
